module.exports = __webpack_public_path__ + "media/assets/icons/CP-broker grey-feb15503c2b5affed22504e8b1104cca.svg";